<template>
    <v-touch @swiperight="onClickLeft" class="wrapper">
        <div class="supplyVolume">
            <van-nav-bar
                title="供应方量"
                left-text="合同列表"
                left-arrow
                @click-left="onClickLeft"
            >
            </van-nav-bar>
            <section>
                <header>
                    <div class="headerContent">
                        <div class="head">
                            <h3>{{ detail.client_name }}</h3>
                            <p>{{ detail.engineering_name }}</p>
                        </div>
                        <van-divider></van-divider>
                        <div class="progress-wrapper">
                            <div class="progress-content">
                                <p :style="{width: `${progressWidth}%`}"></p>
                                <span v-if="progressNumber <= 0" :style="{left: `calc(${progressWidth}% - 10px)`}">{{ progressNumber }}%</span>
                                <span v-else :style="{left: `calc(${progressWidth}% - 22px)`}">{{ progressNumber }}%</span>
                            </div>
                        </div>
                        <div class="sort">
                            <div class="row">
                                <div class="item item1">
                                    <div class="text">
                                        <span class="iconfont icontijikongjian"></span>
                                        <span>预计方量</span>
                                    </div>
                                    <div class="volume" :title="detail.projected_capacity">
                                        {{ detail.projected_capacity }}m³
                                    </div>
                                </div>
                                <div class="item item2">
                                    <div class="text">
                                        <span class="iconfont icontijikongjian"></span>
                                        <span>订单方量</span>
                                    </div>
                                    <div class="volume">
                                        {{ detail.order_total_quantity }}m³
                                    </div>
                                </div>
                                <div class="item item3">
                                    <div class="text">
                                        <span class="iconfont iconrili"></span>
                                        <span>最近一个订单时间</span>
                                    </div>
                                    <div class="volume">
                                        {{ detail.latest_order_time|getTime }}
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="item item4">
                                    <div class="text">
                                        <span class="iconfont icontijikongjian"></span>
                                        <span>已发货方量</span>
                                    </div>
                                    <div class="volume">
                                        {{ detail.delivery_total_quantity }}m³
                                    </div>
                                </div>
                                <div class="item item5">
                                    <div class="text">
                                        <span class="iconfont icontijikongjian"></span>
                                        <span>剩余方量</span>
                                    </div>
                                    <div class="volume">
                                        {{ detail.surplus_capacity }}m³
                                    </div>
                                </div>
                                <div class="item item6">
                                    <div class="text">
                                        <span class="iconfont iconrili"></span>
                                        <span>最近一次发货时间</span>
                                    </div>
                                    <div class="volume">
                                        {{ detail.latest_supply_time|getTime }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </header>
                <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
                    <div class="warpper">
                        <van-list
                            v-model="loading"
                            :finished="finished"
                            finished-text="没有更多了"
                            @load="onLoad"
                        >
                            <div
                                class="materialPlan-item"
                                v-for="(item,index) in orderList"
                                :key="index"
                            >
                                <ul>
                                    <li>
                                        <span class="pre-icon materialPlan01"></span>
                                        <span class="info">施工部位：{{ item.place_name }}</span>
                                    </li>
                                    <li>
                                        <span class="pre-icon materialPlan02"></span>
                                        <span class="info">产品型号：{{ item.strength_grade_special_require }}</span>
                                    </li>
                                    <li>
                                        <van-row>
                                            <van-col span="12">
                                                <span class="pre-icon materialPlan02"></span>
                                                <span class="info">浇筑方式：{{ item.pouring_name }}</span>
                                            </van-col>
                                            <van-col span="12">
                                                <span class="pre-icon materialPlan03"></span>
                                                <span class="info">订单方量：{{ item.quantity }}m³ </span>
                                            </van-col>
                                        </van-row>
                                    </li>
                                    <li>
                                        <van-row>
                                            <van-col span="12">
                                                <span class="pre-icon materialPlan03"></span>
                                                <span class="info">完成方量：{{ item.grand_total_complete_quantity }}m³ </span>
                                            </van-col>
                                            <van-col span="12">
                                                <span class="pre-icon materialPlan04"></span>
                                                <span class="info">累计车次：{{ item.grand_total_vehicle }}次</span>
                                            </van-col>
                                        </van-row>
                                    </li>
                                    <li>
                                        <span class="pre-icon materialPlan05"></span>
                                        <span class="info">要求到货时间：{{ item.arrival_time }}</span>
                                    </li>
                                </ul>
                                <div class="btn-con">
                                    <div class="btn-item" @click="openOrderDetails(item)">
                                        <span class="btn-span">订单详情</span>
                                    </div>
                                    <div class="btn-item" @click="openInvoiceList(item.order_number)">
                                        <span class="btn-span">发货单列表</span>
                                    </div>
                                </div>
                            </div>
                        </van-list>
                    </div>
                </van-pull-refresh>
            </section>
        </div>
    </v-touch>
</template>
<script>
export default {
    // 供应方量
    name: 'supply-volume',
    beforeRouteLeave(to, from, next) {
        if (to.path === '/contractProgress') {
            this.keywords = '';
            this.$store.commit('noKeepAlive', 'supply-volume');
        }
        next();
    },
    components: {},
    props: {},
    data() {
        return {
            // 上一个页面带过来的合同信息
            detail: {},
            suppleVolume: {
                projected_capacity: 0, // 预计方量
                volume: 0, // 发货方量
                sign_volume: 0, // 签收方量
                supply_time_first: '', // 首次供应时间
            },
            progressWidth: 0,
            progressNumber: 0,
            // 下拉刷新
            isLoading: false,
            loading: false,
            finished: false,
            orderList: [],
            pageindex: 1,
            // 列表总条数
            total: 0,
        };
    },
    computed: {},
    filters: {
        getTime: value => {
            let str = '';
            if (value) {
                str = value.substr(0, 10);
            }
            return str;
        },
    },
    watch: {},
    created() {},
    mounted() {
        this.detail = JSON.parse(JSON.stringify(this.$route.params.obj));
        if (this.detail.projected_capacity) {
            if (Number(this.detail.projected_capacity) !== 0) {
                if (Number(this.detail.projected_capacity) !== 0) {
                    const pwidth = (Number(this.detail.delivery_total_quantity) / Number(this.detail.projected_capacity) * 100).toFixed(2);
                    if (Number(pwidth) > 100) {
                        this.progressWidth = 100;
                    } else if (Number(pwidth) < 0) {
                        this.progressWidth = 0;
                    } else {
                        this.progressWidth = pwidth;
                    }
                    this.progressNumber = pwidth;
                } else {
                    this.progressWidth = 0;
                    this.progressNumber = 0;
                }
            }
        }
    },
    destroyed() {},
    methods: {
        // 返回上一页/右划回退
        onClickLeft() {
            this.$router.isBack = 1;
            this.$router.go(-1);
        },

        // 下拉刷新
        onRefresh() {
            this.pageindex = 0;
            this.finished = false;
            this.loading = true;
            this.onLoad();
        },
        // 分页拉取
        onLoad() {
            if (this.isLoading) {
                this.orderList = [];
                this.isLoading = false;
            }
            this.pageindex += 1;
            this.orderListPage();
        },
        // 订单列表
        orderListPage() {
            this.$axios
                .get(`/interfaceApi/production/productorder/get_supply_contract/order_list/${this.detail.contract_number}?pageindex=1&pagesize=2`)
                .then(res => {
                    this.total = res.total;
                    this.loading = false;
                    this.isLoading = false;
                    this.orderList = this.orderList.concat(res.rows);
                    if (this.orderList.length >= this.total) {
                        this.finished = true;
                    }
                })
                .catch(error => {
                    this.$dialog({ message: error.ErrorCode.Message });
                });
        },
        // 打开订单详情
        openOrderDetails(data) {
            this.$router.isBack = 2;
            this.$router.push({
                name: 'orderDetails',
                params: {
                    data: data,
                },
            });
        },
        // 打开发货单列表
        openInvoiceList(orderNumber) {
            this.$router.isBack = 2;
            this.$router.push({
                name: 'invoiceList',
                params: {
                    order_number: orderNumber,
                },
            });
        },
    },
};
</script>
<style lang="stylus" scoped>
@import '~@/assets/styles/mixins.styl';
.supplyVolume
    height 100%
    section
        height calc(100% - 45rpx)
        header
            background #2b5dab
            padding 15rpx
            .headerContent
                background #fff
                border-radius 4rpx
                .head
                    padding 14rpx
                    h3
                        font-size 16rpx
                        color #333333
                        margin-bottom 10rpx
                    p
                        font-size 14rpx
                        color #979EA7
                .van-divider
                    margin 0
                    border-style dashed
                    border-color #979ea7
                .progress-wrapper
                    padding 25rpx 15rpx 10rpx 15rpx
                    .progress-content
                        height 18rpx
                        background rgba(254,247,235,1)
                        border 2px solid rgba(250,132,54,1)
                        border-radius 10px
                        position relative
                        padding 2rpx
                        p
                            height 10rpx
                            background #3495FB
                            border-radius 10rpx
                            transition all 2s
                        span
                            background #3495FB
                            height 20rpx
                            color #ffffff
                            position absolute
                            top -22rpx
                            font-size 12rpx
                            border-radius 4rpx
                            text-align center
                            line-height 20rpx
                            padding 0 3rpx
                            &::after
                                content ""
                                width 0
                                height 0
                                border 4rpx solid
                                border-color #3495FB transparent  transparent  transparent
                                position absolute
                                left 50%
                                margin-left -3rpx
                                bottom -8rpx
                .sort
                    overflow hidden
                    padding 0 10rpx
                    .row
                        display flex
                        justify-content space-between
                        .item
                            margin 10rpx 4rpx
                            .text
                                font-size 12rpx
                                color #979EA7
                                .iconfont
                                    font-size 12rpx
                                    margin-right 5rpx
                            .volume
                                height 22rpx
                                line-height 22rpx
                                margin-top 3rpx
                                text-align center
                                font-size 16rpx
                                text-ellipsis()
                            &.item1
                                .volume
                                    background rgba(250, 132, 54, 0.06)
                                    color #fa8436
                                    width 80rpx
                            &.item2
                                .volume
                                    background rgba(85, 136, 241, 0.06)
                                    color #5588F1
                                    width 80rpx
                            &.item3
                                .volume
                                    background rgba(33, 189, 204, 0.06)
                                    color #21BDCC
                                    width 120rpx
                            &.item4
                                .volume
                                    background rgba(134, 107, 238, 0.06)
                                    color #866BEE
                                    width 80rpx
                            &.item5
                                .volume
                                    background rgba(248, 165, 1, 0.06)
                                    color #F8A501
                                    width 80rpx
                            &.item6
                                .volume
                                    background rgba(33, 189, 204, 0.06)
                                    color #21BDCC
                                    width 120rpx
        .van-pull-refresh
            height calc(100% - 290rpx)
            overflow: scroll;
            -webkit-overflow-scrolling: touch;
            background #F0F0F0
            display flex
            flex-direction column
            .warpper
                background #F0F0F0
                padding 15rpx
                position relative
                .materialPlan-item
                    width 100%
                    background #ffffff
                    margin-bottom 15rpx
                    position relative
                    overflow hidden
                    color #666666
                    font-size 14rpx
                    .connect
                        position absolute
                        bottom 70rpx
                        right 15rpx
                        padding 5rpx 15rpx
                        border 1px solid #5588F1
                        border-radius 4rpx
                        color #5588F1
                    ul
                        padding 16rpx 16rpx 5rpx 16rpx
                        border-bottom 1px solid #F0F0F0
                        li
                            overflow hidden
                            margin-bottom 10rpx
                            .pre-icon
                                width 16rpx
                                height 16rpx
                                float left
                                background-size 100% 100%
                                background-repeat no-repeat
                                display inline-block
                                margin 2rpx 10rpx 0 0
                                &.materialPlan01
                                    background-image url(./../../../assets/images/icons/icon_gy_2.png)
                                &.materialPlan02
                                    background-image url(./../../../assets/images/icons/icon_gy_3.png)
                                &.materialPlan03
                                    background-image url(./../../../assets/images/icons/icon_30.png)
                                &.materialPlan04
                                    background-image url(./../../../assets/images/icons/icon_19.png)
                                &.materialPlan05
                                    background-image url(./../../../assets/images/icons/icon_gy_7.png)
                            .info
                                float left
                                width calc(100% - 26rpx)
                            &.tit
                                font-size 16rpx
                                .icondanjubianhao
                                    color #3495FB
                                    font-size 18rpx
                                    margin 3rpx 8rpx 0 0
                                    float left
                    .btn-con
                        display flex
                        position relative
                        &:after
                            content ''
                            height 15rpx
                            width 1px
                            background #D7D7D7
                            position absolute
                            left 50%
                            top 15rpx
                        .btn-item
                            flex 1
                            text-align center
                            margin 8rpx 0
                            .btn-span
                                border 1px solid #5588F1
                                display inline-block
                                text-align center
                                color #5588F1
                                border-radius 3rpx
                                padding 4rpx 8rpx
                        .btn-item01
                            position relative
                            &:before
                                content ' '
                                position absolute
                                right 0
                                width 1px
                                height 15rpx
                                background #D7D7D7
                                top 8rpx
</style>
